import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randPhrase } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type PatientLocationAttributeData =
  SchemaAttributes<'PatientLocationAttribute'>

export const model = Model as ModelDefinition<PatientLocationAttributeData>

export const factory = Factory.extend<PatientLocationAttributeData>({
  name() {
    return randPhrase({ maxCharCount: 40 })
  },
})

export function routes(server: MockServer) {
  server.resource('patientLocationAttribute', {
    path: '/patient_location_attribute',
  })

  server.get('/patient_location_attributes', function (schema) {
    return schema.all('patientLocationAttribute')
  })
}

export function seeds(server: MockServer) {
  server.createList('patientLocationAttribute', 10)
}
